module.exports = __webpack_public_path__ + "static/media/THURROCK_APP_LOGO.1f9aa1fb.png";